import base from '../httpApi/base'; // 导入接口域名列表
import axios from '../httpApi/http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块
import { param } from 'jquery';
const TopicApi = {
    //#region 後臺接口
    //獲取文章列表
    GetArticleList(params) {
        return axios.get(`${base.dev}/services/app/AdminNewArticle/GetAll`, { params })
    },
    //根據id獲取文章
    GetArticle(params) {
        return axios.get(`${base.dev}/services/app/AdminNewArticle/Get`, { params })
    },
    //添加文章
    Addarticle(params) {
        return axios.post(`${base.dev}/services/app/AdminNewArticle/Create`, params)
    },
    //更新文章
    Updatearticle(params) {
        return axios.put(`${base.dev}/services/app/AdminNewArticle/Update`, params)
    },
    //刪除文章
    DelArticle(params) {
        return axios.delete(`${base.dev}/services/app/AdminNewArticle/Delete`, { params: params })
    },
    //加入推荐
    UpdateRecommend(params) {
        return axios.get(`${base.dev}/services/app/AdminNewArticle/UpdateRecommend`, { params })
    },
    //取消推荐
    UnUpdateRecommend(params) {
        return axios.get(`${base.dev}/services/app/AdminNewArticle/UnUpdateRecommend`, { params })
    },


    //獲取文章類型
    GetArticleType(params) {
        return axios.get(`${base.dev}/services/app/AdminCommonType/GetAll`, { params })
    },
    //根據id獲取文章類型
    getArticleTypeByid(params) {
        return axios.get(`${base.dev}/services/app/AdminCommonType/Get`, { params })
    },
    //新增文章類型
    AddArticleType(params) {
        return axios.post(`${base.dev}/services/app/AdminCommonType/Create`, params)
    },
    //排序
    SortArticleType(params) {
        return axios.post(`${base.dev}/services/app/AdminCommonType/UpdateStore`, params)
    },
    SortAdminTopic(params) {
        return axios.post(`${base.dev}/services/app/AdminNewArticle/UpdateStore`, params)
    },
    //修改文章類型
    EditArticleType(params) {
        return axios.put(`${base.dev}/services/app/AdminCommonType/Update`, params)
    },
    //刪除文章類型
    DelArticleType(params) {
        return axios.delete(`${base.dev}/services/app/AdminCommonType/Delete`, { params: params })
    },


    //獲取轉載列表
    GetReprintList() {
        return axios.get(`${base.dev}/services/app/AdminReprintedSource/GetAll`)
    },
    //根據id獲取轉載來源
    getReprintByid(params) {
        return axios.get(`${base.dev}/services/app/AdminReprintedSource/Get`, { params })
    },
    //新增轉載來源
    AddReprint(params) {
        return axios.post(`${base.dev}/services/app/AdminReprintedSource/Create`, params)
    },
    //修改轉載來源
    EditReprint(params) {
        return axios.put(`${base.dev}/services/app/AdminReprintedSource/Update`, params)
    },
    //刪除轉載來源
    DelReprint(params) {
        return axios.delete(`${base.dev}/services/app/AdminReprintedSource/Delete`, { params: params })
    },

    //#endregion
    //#region 前台接口
    //獲取文章列表
    GetArticleListDesk(params) {
        return axios.get(`${base.dev}/services/app/NewArticle/GetAll`, { params })
    },
    //根據id獲取文章
    GetArticleDesk(params) {
        return axios.get(`${base.dev}/services/app/NewArticle/Get`, { params })
    },
    //獲取文章類型
    GetArticleTypeDesk(params) {
        return axios.get(`${base.dev}/services/app/CommonType/GetAll`, { params })
    },
    pageViews(params) {
        return axios.post(`${base.dev}/services/app/NewArticle/UpdateStatistics`, params)
    },
    //用户收藏的文章
    getFavoriteByUserId(params) {
        return axios.get(`${base.dev}/services/app/NewArticle/getFavoriteByUserId`, { params })
    },


    //#endregion
}
export default TopicApi


// WEBPACK FOOTER //
// ./src/api/Topic/TopicAPi.js